export const CHANGE_BG = "CHANGE_BG"